/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetStorefrontConfig200ResponseConfig
 */
export interface GetStorefrontConfig200ResponseConfig {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetStorefrontConfig200ResponseConfig
     */
    delivery: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetStorefrontConfig200ResponseConfig
     */
    takeAway: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetStorefrontConfig200ResponseConfig
     */
    nextDayOrdering: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetStorefrontConfig200ResponseConfig
     */
    allowSchedule: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetStorefrontConfig200ResponseConfig
     */
    allowAsap: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetStorefrontConfig200ResponseConfig
     */
    maxScheduleDays?: number | null;
}

/**
 * Check if a given object implements the GetStorefrontConfig200ResponseConfig interface.
 */
export function instanceOfGetStorefrontConfig200ResponseConfig(value: object): value is GetStorefrontConfig200ResponseConfig {
    if (!('delivery' in value) || value['delivery'] === undefined) return false;
    if (!('takeAway' in value) || value['takeAway'] === undefined) return false;
    if (!('nextDayOrdering' in value) || value['nextDayOrdering'] === undefined) return false;
    if (!('allowSchedule' in value) || value['allowSchedule'] === undefined) return false;
    if (!('allowAsap' in value) || value['allowAsap'] === undefined) return false;
    return true;
}

export function GetStorefrontConfig200ResponseConfigFromJSON(json: any): GetStorefrontConfig200ResponseConfig {
    return GetStorefrontConfig200ResponseConfigFromJSONTyped(json, false);
}

export function GetStorefrontConfig200ResponseConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorefrontConfig200ResponseConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'delivery': json['delivery'],
        'takeAway': json['takeAway'],
        'nextDayOrdering': json['nextDayOrdering'],
        'allowSchedule': json['allowSchedule'],
        'allowAsap': json['allowAsap'],
        'maxScheduleDays': json['maxScheduleDays'] == null ? undefined : json['maxScheduleDays'],
    };
}

export function GetStorefrontConfig200ResponseConfigToJSON(json: any): GetStorefrontConfig200ResponseConfig {
    return GetStorefrontConfig200ResponseConfigToJSONTyped(json, false);
}

export function GetStorefrontConfig200ResponseConfigToJSONTyped(value?: GetStorefrontConfig200ResponseConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delivery': value['delivery'],
        'takeAway': value['takeAway'],
        'nextDayOrdering': value['nextDayOrdering'],
        'allowSchedule': value['allowSchedule'],
        'allowAsap': value['allowAsap'],
        'maxScheduleDays': value['maxScheduleDays'],
    };
}

